module.exports = __webpack_public_path__ + "18e62e2c8810fa9fe641d9ebce7dda72.svg";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-condensed-italic-webfont.svg
// module id = 443
// module chunks = 0